import React from 'react';
import { Pressable, View } from 'react-native';
import { Avatar, Icon } from 'react-native-paper';

function UserAvatarBadge({
  user, icon, size, triggerProps, style,
}) {
  return (
    <Pressable {...triggerProps} style={[{ width: size, height: size }, style]}>
      {user.profile?.pictureThumbnail ? (
        <Avatar.Image size={size} source={{ uri: user.profile.pictureThumbnail }} />
      ) : (
        <Avatar.Text size={size} label={`${user.firstName[0]}${user.lastName[0]}`} />
      )}
      <View
        style={{
          position: 'absolute',
          bottom: -2,
          right: -2,
          width: size * 0.5,
          height: size * 0.5,
          borderRadius: (size * 0.5) / 2,
          backgroundColor: '#fff',
          borderWidth: 1,
          borderColor: '#ccc',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Icon source={icon} size={size * 0.32} />
      </View>
    </Pressable>
  );
}

UserAvatarBadge.defaultProps = {
  size: 40,
  triggerProps: undefined,
  style: undefined,
};

export default UserAvatarBadge;
